import React from 'react';
import './header.css';
import { Link } from 'react-router-dom';


export default class Header extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      rightBttn: 'Sign Up',
      showsignin: false
    };


  }

  componentDidMount() {
    if(window.location.pathname.includes('signup')) {
      this.setState({
        rightBttn: 'Sign In'
      });
    }
    if(window.location.pathname.includes('forgot-password')) {
      this.setState({
        showsignin: true
      });
    }
  }


  render() {
    return (
      <div>
        <header id="main_header" className="header_cont">
          <div className="container">
            <h1 className="logo_h1"><a href="https://www.idrivecompute.com/index.html" className="logo_cont"></a></h1>
            <div className="login_wrap">
              <ul>
                { this.state.showsignin ? <li><Link to="/login" className="signin">Sign in</Link></li> : "" }
                {/* { this.state.showsignin ? <li><Link to="/login" className="signin">Sign in</Link></li> : "" }
                <li>{ this.state.rightBttn === 'Sign Up' ? <Link to="/signup" className="signup">{ this.state.rightBttn }</Link> : <Link to="/login" className="signup">{ this.state.rightBttn }</Link> }</li>
                <li><Link to="myaccount" className="myaccount">My account</Link></li> */}
              </ul>
            </div>

            <div className="menu_cont">
              <ul>
                <li><a href="/features.htm" >Features</a></li>
                <li><a href="/pricing.htm" >Pricing</a></li>
                <li><a href="/instance.htm" >Instances</a></li>
                <li><a href="/block-storage.htm" >Block Storage</a></li>
                <li><a href="/support.htm" >Support</a></li>
                <li><a href="/faq.htm" >FAQs</a></li>
                <li className="tutorial_link"><a href="/video.htm">Tutorials</a></li>
              </ul>
            </div>
          </div>
        </header>

        { this.state.rightBttn === 'Sign In' ? <header className="mobile_header signup_page" /> : <header className="mobile_header signin_page" /> }


      </div>
    );
  }
}